'use client'
import { Link } from '@/i18n/routing'
import { IconChevronDown } from '@tabler/icons-react'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import { FC } from 'react'
import { isLinkActive, type MenuColumn } from '../menu'

type MobileNavSectionProps = {
  id: string
  menuId: string
  label: string
  columns: MenuColumn[]
  isOpen: boolean
  isActive: boolean
  pathname: string
  onToggle: () => void
}

// Mobile Variante des Mega-Menues: ein Akkordeon je Hauptpunkt, die Spalten
// werden zu Gruppen untereinander. Hoehe per grid-template-rows 0fr/1fr, das
// animiert ohne gemessene Pixelwerte.
const MobileNavSection: FC<MobileNavSectionProps> = ({ id, menuId, label, columns, isOpen, isActive, pathname, onToggle }) => {
  const t = useTranslations('navigation')

  return (
    <li className="flex flex-col">
      <button
        type="button"
        aria-expanded={isOpen}
        aria-controls={id}
        onClick={onToggle}
        className={classNames('flex w-full items-center justify-between text-left text-lg leading-6 cursor-pointer', isActive ? 'font-medium text-accent' : 'font-light text-white')}
      >
        {label}
        <IconChevronDown size={20} aria-hidden="true" className={classNames('transition-transform duration-200 motion-reduce:transition-none', isOpen && 'rotate-180')} />
      </button>
      <div id={id} inert={!isOpen} className={classNames('grid transition-[grid-template-rows] duration-300 ease-out motion-reduce:transition-none', isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]')}>
        <div className="overflow-hidden">
          <div data-nav-menu={menuId} className="flex flex-col gap-y-6 pt-6 pb-2">
            {columns.map((column) => (
              <div key={column.title}>
                <p className="mb-3 text-xs uppercase tracking-[0.2em] text-KMRSx24-GreyLight">{t(column.title)}</p>
                <ul className="flex flex-col gap-y-3">
                  {column.links.map((link) => {
                    const linkIsActive = isLinkActive(pathname, link)
                    return (
                      <li key={link.href} className="flex">
                        <Link
                          href={link.href}
                          data-nav-link={link.href}
                          aria-current={linkIsActive ? 'page' : undefined}
                          className={classNames('text-base leading-6', linkIsActive ? 'font-medium text-accent' : link.highlight ? 'font-light text-accent' : 'font-light text-white')}
                        >
                          {t(link.label)}
                        </Link>
                      </li>
                    )
                  })}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </li>
  )
}

export default MobileNavSection
